<svelte:head>
	<title>The Chronicle | Community Lands</title>
	<meta
		name="description"
		content="Read up on the latest in the real-estate market or learn about topics relevant to home-owners in The Chronicle!"
	/>
	<meta property="og:title" content="The Chronicle | Community Lands" />
	<meta
		property="og:description"
		content="Read up on the latest in the real-estate market or learn about topics relevant to home-owners in The Chronicle!"
	/>
	<meta name="twitter:title" content="The Chronicle | Community Lands" />
	<meta
		name="twitter:description"
		content="Read up on the latest in the real-estate market or learn about topics relevant to home-owners in The Chronicle!"
	/>
</svelte:head>
<slot />
